module.exports = __webpack_public_path__ + "static/media/Maldives.473b3b8a.png";